import { ChangeDetectionStrategy, Component } from '@angular/core'

import { Confirmable } from '@app/modules/ui/models/confirmable'
import { UIModule } from '@app/modules/ui/ui.module'

@Component({
  selector: 'sb-conversation-remove-confirm-modal',
  templateUrl: './conversation-remove-confirm-modal.component.html',
  imports: [UIModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConversationRemoveConfirmModalComponent extends Confirmable {}
